module.exports = __webpack_public_path__ + "static/media/SOAR_Award_2020.a505ed01.png";